import { API_BASE_URL } from "../config";
import React, { useState, useEffect } from "react";
import axios from "axios";

const RiskMonitor = () => {
  const [riskData, setRiskData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRisk = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/admin/risk-monitor`);
      setRiskData(Array.isArray(res.data) ? res.data : (res.data?.RiskData?.toLowerCase() || res.data?.data || res.data?.items || res.data?.users || res.data?.trades || res.data?.holdings || res.data?.positions || res.data?.orders || res.data?.logs || res.data?.withdrawals || []));
    } catch (err) {
      console.error("Error fetching risk data", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRisk();
  }, []);

  const highRiskList = riskData.filter((r) => r.isHighRisk);

  return (
    <div>
      <div style={{ marginBottom: "20px" }}>
        <h2 style={{ margin: 0, color: "#fff" }}>Risk & Margin Exposure Monitoring</h2>
        <p style={{ margin: "4px 0 0", color: "#b2b5be", fontSize: "14px" }}>
          Real-time risk dashboard highlighting high margin utilization and over-exposed paper-trading accounts
        </p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "24px" }}>
        <div style={{ backgroundColor: "#1e222d", padding: "18px", borderRadius: "8px", borderLeft: "4px solid #ef5350", border: "1px solid #2a2e39" }}>
          <div style={{ fontSize: "12px", color: "#b2b5be", textTransform: "uppercase" }}>High Risk Flagged Accounts</div>
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "#ef5350", marginTop: "6px" }}>
            {highRiskList.length} Client(s)
          </div>
        </div>

        <div style={{ backgroundColor: "#1e222d", padding: "18px", borderRadius: "8px", borderLeft: "4px solid #4caf50", border: "1px solid #2a2e39" }}>
          <div style={{ fontSize: "12px", color: "#b2b5be", textTransform: "uppercase" }}>Total Monitored Wallets</div>
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "#4caf50", marginTop: "6px" }}>
            {riskData.length} Wallet(s)
          </div>
        </div>
      </div>

      <div style={{ backgroundColor: "#1e222d", borderRadius: "8px", overflow: "hidden", border: "1px solid #2a2e39" }}>
        <div style={{ padding: "16px", borderBottom: "1px solid #2a2e39" }}>
          <h3 style={{ margin: 0, color: "#fff", fontSize: "16px" }}>Margin Utilization & Risk Alerts</h3>
        </div>

        {loading ? (
          <div style={{ padding: "20px", color: "#888" }}>Evaluating account margin exposure...</div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
            <thead>
              <tr style={{ backgroundColor: "#2a2e39", color: "#b2b5be", textAlign: "left" }}>
                <th style={thStyle}>Client</th>
                <th style={thStyle}>Email</th>
                <th style={thStyle}>Virtual Balance</th>
                <th style={thStyle}>Margin Used</th>
                <th style={thStyle}>Margin Available</th>
                <th style={thStyle}>Margin Utilization</th>
                <th style={thStyle}>Risk Status</th>
              </tr>
            </thead>
            <tbody>
              {riskData.map((item, idx) => {
                const w = item.wallet || {};
                const u = w.userId || {};
                return (
                  <tr key={w._id || idx} style={{ borderBottom: "1px solid #2a2e39", backgroundColor: item.isHighRisk ? "rgba(239, 83, 80, 0.05)" : "transparent" }}>
                    <td style={{ ...tdStyle, fontWeight: "bold", color: "#fff" }}>{u.name || "N/A"}</td>
                    <td style={tdStyle}>{u.email || "N/A"}</td>
                    <td style={tdStyle}>₹{w.virtualBalance?.toLocaleString()}</td>
                    <td style={{ ...tdStyle, color: "#ff9800", fontWeight: "bold" }}>₹{w.marginUsed?.toLocaleString()}</td>
                    <td style={tdStyle}>₹{w.marginAvailable?.toLocaleString()}</td>
                    <td style={{ ...tdStyle, fontWeight: "bold" }}>
                      {item.utilizationPercentage}%
                    </td>
                    <td style={tdStyle}>
                      <span
                        style={{
                          padding: "2px 8px",
                          borderRadius: "10px",
                          fontSize: "11px",
                          fontWeight: "bold",
                          backgroundColor: item.isHighRisk ? "rgba(239, 83, 80, 0.2)" : "rgba(76, 175, 80, 0.15)",
                          color: item.isHighRisk ? "#ef5350" : "#4caf50",
                        }}
                      >
                        {item.isHighRisk ? "⚠️ HIGH RISK EXPOSURE" : "NORMAL"}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

const thStyle = { padding: "12px", fontSize: "12px", textTransform: "uppercase" };
const tdStyle = { padding: "12px", color: "#d1d4dc" };

export default RiskMonitor;
